module.exports = __webpack_public_path__ + "static/media/logo.0a3d7d7b.png";